import { sqAxiosStore } from '@/core/core.stores';

export const addRequest = (id: string) => sqAxiosStore.actions.addRequest(id);

export const removeRequest = (id: string) => sqAxiosStore.actions.removeRequest(id);
